import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import CloseIcon from '@material-ui/icons/Close';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuList from '@material-ui/core/MenuList';
import * as React from 'react';
import ActionBarAction from './ActionBarAction';
import useStyles from './ActionBarSelect.styles';
export const ActionBarSelect = ({ icon, label, disabled, open = false, onOpen = () => { }, children, }) => {
    const classes = useStyles();
    const anchorRef = React.useRef(null);
    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            // @ts-ignore
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [open]);
    return (_jsxs(_Fragment, { children: [_jsx(ActionBarAction, { ref: anchorRef, icon: open ? _jsx(CloseIcon, {}) : icon, label: label, disabled: disabled, selected: open, onClick: () => onOpen(!open) }), _jsx(Popper, Object.assign({ className: classes.dropdown, open: open, anchorEl: anchorRef.current, placement: "bottom", transition: true, disablePortal: true }, { children: ({ TransitionProps, placement }) => (_jsx(Grow, Object.assign({}, TransitionProps, { style: {
                        transformOrigin: placement === 'bottom' ? 'left top' : 'left bottom',
                    } }, { children: _jsx(Paper, Object.assign({ className: classes.paper, elevation: 3 }, { children: _jsx(ClickAwayListener, Object.assign({ onClickAway: () => onOpen(false) }, { children: _jsx(MenuList, Object.assign({ className: classes.menuList, autoFocusItem: open }, { children: children })) })) })) }))) }))] }));
};
export default ActionBarSelect;
//# sourceMappingURL=ActionBarSelect.js.map